(() => {
  const form = document.getElementById('ProductForm');
  const productJson = document.querySelector('[id^="ProductJson-"]');
  if (!form || !productJson) return;

  let product;
  try {
    product = JSON.parse(productJson.textContent);
  } catch {
    return;
  }

  const variantInput = document.getElementById('ProductVariantId');
  const priceEl = document.getElementById('ProductPrice');
  const selects = [...form.querySelectorAll('[data-option-index]')];
  const submit = form.querySelector('[type="submit"]');

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format(cents / 100);
    } catch {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const findVariant = () => {
    const values = selects.map((s) => s.value);
    return product.variants.find((v) =>
      v.options.every((opt, i) => opt === values[i])
    );
  };

  const sync = () => {
    const variant = findVariant();
    if (!variant) return;
    variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
  };

  selects.forEach((s) => s.addEventListener('change', sync));
})();
